<div class="to-top-btn" [ngClass]="{'visible': toTopVisible}" (click)="onToTopClick()" (touchend)="onToTopClick()">
  <i class="icon-arrow"></i>
</div>
